import { useState } from "react"
import { ChevronDownIcon } from "@heroicons/react/24/outline"
import { H2, Paragraph, SmallText } from "../typography/Typography"
import { ANALYTICS_EVENTS, track } from "../../lib/analytics"

type FAQItem = {
  question: string
  answer: string
}

type FAQProps = {
  items: FAQItem[]
}

export const generateFAQSchema = (items: FAQItem[]) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "name": "Frequently Asked Questions",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer
      }
    }))
  }
}

export const FAQSection = ({ items }: FAQProps) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <div className="px-8 md:px-24 py-4 md:py-8 flex flex-col gap-8">
      <H2>Frequently Asked Questions</H2>

      <div className="flex flex-col gap-4">
        {items.map((item, index) => {
          const isOpen = openIndex === index

          return (
            <div
              key={index}
              className="border border-gray-200 rounded-xl bg-white overflow-hidden"
            >
              <button
                onClick={() => {
                  const willOpen = !isOpen
                  if (willOpen) {
                    track(ANALYTICS_EVENTS.FAQ_TOGGLED, { question: item.question, index })
                  }
                  setOpenIndex(willOpen ? index : null)
                }}
                className="w-full flex items-center justify-between p-4 md:p-6 text-left"
              >
                <SmallText className="text-gray-900">
                  {item.question}
                </SmallText>

                <ChevronDownIcon
                  className={`size-5 text-gray-500 transition-transform ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              {isOpen && (
                <div className="px-4 md:px-6 pb-4 md:pb-6">
                  <Paragraph className="text-gray-600">
                    {item.answer}
                  </Paragraph>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}